export const Logo = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-label="Daybreyk">
    <rect width="100" height="100" rx="26" fill="#0E1A38" />
    <path d="M24 62a26 26 0 0 1 52 0" stroke="#C8102E" strokeWidth="8" strokeLinecap="round" />
    <path d="M18 74h64" stroke="#D9AE34" strokeWidth="7" strokeLinecap="round" />
    <path d="M50 24v8M28 34l5 5M72 34l-5 5" stroke="#FFFFFF" strokeWidth="6" strokeLinecap="round" />
  </svg>
);
